import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import Settings from "./Settings";
import Common from "./Common";
import Notifications from "./Notifications";
import Tipo from "./Tipo";

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    common: Common,
    notifications: Notifications,
    tipo: Tipo,
  });

export default createRootReducer;
